import commonActions from "./actions";

const initialState = {
  alert: { status: null, show: false, message: null },
  pageLoader: false,
  buttonLoader: false,
  showModal: {
    show: false,
    type: null,
    method: null,
    data: null,
  },
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case commonActions.SET_ALERT:
      return {
        ...state,
        alert: action.payload,
      };
    case commonActions.SET_PAGE_LOADER:
      return {
        ...state,
        pageLoader: action.payload,
      };
    case commonActions.SET_BUTTON_LOADER:
      return {
        ...state,
        buttonLoader: action.payload,
      };
    case commonActions.SET_SHOW_MODAL:
      return {
        ...state,
        showModal: action.payload,
      };
    default:
      return state;
  }
};

export default commonReducer;
